import styled from 'styled-components'
import { device } from 'src/theme/theme'

export const NewsContainer = styled.div`
  padding: 0 0 3.75rem;
  max-width: 900px;
  margin: 0 auto;
  white-space: pre-wrap;

  .player-wrapper {
    position: relative;
    padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
    margin-bottom: ${p => p.theme.spacing.medium};
  }

  .react-player {
    position: absolute;
    top: 0;
    left: 5%;
  }

  .content-news {
    max-width: 90%;
    margin: 0 auto;

    @media ${device.laptop} {
      max-width: 100%;
    }
  }

  .desc {
    ${({ theme }) => ({ ...theme.size.sm })}
    color: ${({ theme }) => theme.colors.secondaryTextColor};
    @media ${device.laptop} {
      padding: 0;
    }
    white-space: pre-wrap;

    p {
      margin-bottom: 20px;
    }
  }
`
